module.exports = __webpack_public_path__ + "img/couples_19_V.cad373b5.webp";